const EXPIRING_SOON_DAYS = 7;

const parseExpirationDate = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }
    return parsed;
};

export const getDaysUntilExpiration = (expiresAt) => {
    const parsed = parseExpirationDate(expiresAt);
    if (!parsed) return null;
    const diffMs = parsed.getTime() - Date.now();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

export const getExpirationStatus = (expiresAt) => {
    const parsed = parseExpirationDate(expiresAt);
    if (!parsed) return "no-expiration";
    const diffDays = getDaysUntilExpiration(parsed);
    if (diffDays <= 0) return "expired";
    if (diffDays <= EXPIRING_SOON_DAYS) return "expiring-soon";
    return "active";
};

export const formatExpirationDate = (expiresAt) => {
    const parsed = parseExpirationDate(expiresAt);
    if (!parsed) return null;
    return parsed.toLocaleString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const calculateExpirationDate = (duration, baseDate = new Date()) => {
    if (!duration) return null;
    const base = new Date(baseDate);

    switch (duration) {
        case "1-week":
            return new Date(base.getTime() + 7 * 24 * 60 * 60 * 1000);
        case "30-days":
            return new Date(base.getTime() + 30 * 24 * 60 * 60 * 1000);
        case "until-complete":
            return null;
        default:
            return null;
    }
};

export const expirationLabels = {
    expired: "Expired",
    "expiring-soon": "Expiring soon",
    active: "Active",
    "no-expiration": "No expiration",
};

export { EXPIRING_SOON_DAYS };
